var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hubFooter"}},[_c('b-navbar',{staticClass:"row "},[_c('b-navbar-brand',{staticClass:"col-2 alignVert"},[_c('div',{staticClass:"mt-1 mb-1"},[_c('img',{attrs:{"id":"headerImage","src":"img/ArcadisLogo.png"}})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }